var exports = {
  "VA": "x2b2fbebb--e3a1da--subtitle",
  "UU": "x2b2fbebb--e3a1da--name",
  "uW": "x2b2fbebb--e3a1da--section",
};

module.exports = exports;
